import { Effect, Layer } from 'effect';
import { GavelConfig } from '../../../../services/gavelConfig';
import { AxiosHttpService, HttpService } from '../../../../services/http';
import { TokenProviderService } from '../../../../services/tokenProvider';
import { Get, makeGetRequestResolver } from './gavelService/requests';
import { PrologRuleService } from './service';
const makeGavelPrologRuleService = Effect.gen(function* () {
    const http = yield* HttpService;
    const tokenService = yield* TokenProviderService;
    const { gavelUrl: baseUrl } = yield* GavelConfig;
    const get = (tenant, ruleId) => tokenService.getToken().pipe(Effect.andThen(token => Effect.request(new Get({
        baseUrl,
        prologRuleId: ruleId,
        tenant,
        token: `Bearer ${token}`,
    }), makeGetRequestResolver(http))));
    return { get };
});
export const BaseGavelPrologRuleService = Layer.effect(PrologRuleService, makeGavelPrologRuleService);
export const DefaultGavelPrologRuleService = BaseGavelPrologRuleService.pipe(Layer.provide(AxiosHttpService));
